import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import { Component, Provide, Watch } from 'vue-property-decorator';
import router from '../../router';
import util from '../../shared/util';
import store from '../../store';
import Foot from '../foot';
import MessageModel from '../messageModel';
import Navbar from '../navbar';
import Sidebar from '../sidebar';
import template from './layout.vue';

@Component({
    mixins: [template],
    store,
    components: {
        Navbar,
        Sidebar,
        Foot,
        MessageModel,
    },
    router,
})
class Layout extends Vue {
    isFold: boolean = false;
    isRouterAlive: boolean = true;

    @Provide('reload')
    reload() {
        this.isRouterAlive = false;
        this.$nextTick(() => {
            this.isRouterAlive = true;
        });
    }

    mounted() {
        window.onbeforeunload = (e: any) => {
            let payMents = localStorage.getItem(util.Base64EncodetoString('AddPayMents'));
            alert(payMents);
            if (payMents) {
                localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
                return false;
            }
        };
    }

    onSidebar(isFold: any) {
        this.isFold = !isFold;
    }

    hideForLogin() {
        let userId = localStorage.getItem('UserID');
        if (userId !== null && parseInt(userId) > 0) {
            return true;
        }
        return false;
    }
    // messageModel
    get messageModel() {
        return this.$store.getters.messageModel;
    }

    @Watch('messageModel.isShowMessageModel', { deep: true, immediate: true })
    onMessageModelChange(val: any, oldVal: any, event: any) {
        if (val && val !== oldVal) {
            this.showMessageModal();
        }
    }

    showMessageModal() {
        this.$modal.show(this.messageModel.messageName);
    }

    closeMessageModel() {
        this.messageModel.isShowMessageModel = false;
        this.messageModel.messageModelTitle = '';
        this.messageModel.messageModelMessage = '';
        this.messageModel.backToHome = false;
        this.$store.dispatch('updateMessageModel', this.messageModel);
    }
}
export default Layout;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/layout/index.ts